import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"

import { StandardButton } from "../buttons/StandardButton"
import { StandardDialog } from "./StandardDialog"

const useStyles = makeStyles()((theme) => ({
    content: {
        padding: "2rem",
        paddingTop: "1rem",
    },
    message: {
        color: theme.palette.text.primary,
        textAlign: "center",
    },
}))

type Props = Readonly<{
    open: boolean
    onClose: () => void
}>

/** Informational dialog for features that are not released yet. */
export function ComingSoonDialog({ open, onClose }: Props) {
    const { classes } = useStyles()

    return (
        <StandardDialog
            open={open}
            onClose={onClose}
            maxWidthProp="xs"
            dialogTitle={
                <LocalizedStrict id="coming-soon-dialog-title">
                    <>Coming soon</>
                </LocalizedStrict>
            }
        >
            <Stack spacing="1.5rem" className={classes.content}>
                <LocalizedStrict id="coming-soon-dialog-message">
                    <Typography variant="body1" className={classes.message}>
                        We are working to bring you this feature.
                    </Typography>
                </LocalizedStrict>
                <LocalizedStrict id="coming-soon-dialog-ok-button">
                    <StandardButton onClick={onClose}>OK</StandardButton>
                </LocalizedStrict>
            </Stack>
        </StandardDialog>
    )
}
